// TOUR-25 — Logistics carriers / hauler admin.

import { LOGISTICS_COORDINATOR_ROLES } from "@/lib/roles/turboLogisticsRoles";
import type { FireflyTourArtifact } from "../tourTypes";

export const LOGISTICS_CARRIERS_TOUR_ID = "tour-logistics-carriers";

export const LOGISTICS_CARRIERS_TOUR: FireflyTourArtifact = {
  id: LOGISTICS_CARRIERS_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "carriers tour",
    "add a hauler",
    "haulers tour",
    "walk me through carriers",
    "show me carrier admin",
  ],
  bucketRelevance: ["logistics"],
  requiredRoles: [...LOGISTICS_COORDINATOR_ROLES],
  steps: [
    {
      id: "nav-carriers",
      target: {
        mode: "logisticsCarriers",
        anchorId: "mode-nav-logisticsCarriers",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "logisticsCarriers",
      copy: {
        title: "Open Carriers",
        body: "Hauler roster, kinds, and active status live here. Tap Carriers in the Logistics bucket (sidebar or bottom bar).",
      },
      waitForClick: true,
    },
    {
      id: "carriers-surface",
      target: {
        mode: "logisticsCarriers",
        anchorId: "logi-carriers-surface",
        scrollIntoView: true,
      },
      copy: {
        title: "Carriers workspace",
        body: "Add contracted, freelance, dealer BYO, or in-house haulers. Active carriers appear in the Routes dispatch picker; inactive stay in history only.",
      },
      advanceOn: "next_button",
    },
    {
      id: "carriers-form",
      target: {
        mode: "logisticsCarriers",
        anchorId: "logi-carriers-form",
        scrollIntoView: true,
      },
      copy: {
        title: "Add a hauler",
        body: "Use + New carrier, fill name / kind / coverage, then Create carrier yourself — the tour will not save a row.",
      },
      advanceOn: "next_button",
    },
    {
      id: "carriers-list",
      target: {
        mode: "logisticsCarriers",
        anchorId: "logi-carriers-list",
        scrollIntoView: true,
      },
      copy: {
        title: "All carriers",
        body: "Filter by kind or active status, then Edit a row, open Routes history, or manage Rigs for fleet capacity.",
      },
      advanceOn: "next_button",
    },
    {
      id: "active-toggle",
      target: {
        mode: "logisticsCarriers",
        anchorId: "logi-carrier-active-toggle",
        scrollIntoView: true,
      },
      copy: {
        title: "Deactivate / Reactivate",
        body: "Deactivate hides a hauler from new route assignments without breaking past routes. You click Deactivate or Reactivate yourself — the tour will not toggle.",
      },
      destructive: true,
    },
    {
      id: "ask-firefly",
      target: { mode: "logisticsCarriers", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Dispatch and stop edits live under Logistics → Routes. Ask Firefly anytime for routes or manufacturing plant tours.",
      },
      advanceOn: "next_button",
    },
  ],
};
